export const stopPropagation = (e) => e.stopPropagation();

export const getDeepValue = (source: Record<string, any>, path: string) => {
  if (path.match(/[.,[]/)) {
    const pathArr = path.split(/[.,[]/g).filter(p => p);

    return pathArr.reduce((acc, current) => {
      if (typeof acc === 'object') {
        return current.match(/]/) ? acc[current.replace(']', '')] : acc[current];
      }

      return acc;
    }, source);
  }

  if (path.match(/\w+\.\w+/)) {
    const pathArr = path.split(/\./g);

    return pathArr.reduce((acc, current) => {
      if (typeof acc === 'object') {
        return acc[current];
      }

      return acc;
    }, source);
  }

  return source[path];
};